export default __webpack_public_path__ + "static/media/vitra_chair_03.15b74395.jpg";